__turbopack_context__.v({
  "comments-container": "_69nl8G_comments-container",
  "comments-form-heading": "_69nl8G_comments-form-heading",
  "comments-title": "_69nl8G_comments-title",
  "comments-title-heading": "_69nl8G_comments-title-heading",
  "comments-title-mobile": "_69nl8G_comments-title-mobile",
  "review-comments-star": "_69nl8G_review-comments-star",
  "reviews-comments-star": "_69nl8G_reviews-comments-star",
  "reviews-info": "_69nl8G_reviews-info",
  "reviews-info-mobile": "_69nl8G_reviews-info-mobile",
  "reviews-subtitle-mobile": "_69nl8G_reviews-subtitle-mobile",
  "reviews-title-mobile": "_69nl8G_reviews-title-mobile",
});
